import { Button, Card, CardContent } from '@material-ui/core';
import React from 'react';
import { Redirect, Route, useHistory } from 'react-router-dom';
import PageEditor from './PageEditor';
import { makeStyles } from '@material-ui/core/styles';

const systemPages = [
	{
		name: "cgu",
		collection: "cgu",
	},
	{
		name: "cgv",
		collection: "cgv",
	},
	{
		name: "Mentions légales",
		collection: "legal",
	},
	{
		name: "A propos",
		collection: "about",
	},
	{
		name: "Cheque",
		collection: "check",
	},
]

const useStyles = makeStyles((theme) => ({
	container: {
		display: 'flex',
		flex: 1,
		flexDirection: 'column'
	},
	buttons: {
		display: 'flex',
		justifyContent: 'space-around',
		flex: 1
	},
	header: {
		marginBottom: '1vh'
	}
}));

const System = () => {
	const classes = useStyles();
	const history = useHistory();
	return (
		<div className={classes.container}>
			<Card className={classes.header}>
				<CardContent className={classes.buttons}>
					{systemPages.map((e) =>
						<Button
							key={e.collection}
							variant={history.location.pathname === `/system/${e.collection}` || history.location.pathname === `/cover` ? 'contained' : 'outlined'}
							onClick={() => history.push(`/system/${e.collection}`)}
						>{e.name}</Button>
					)}
				</CardContent>
			</Card>
			<Redirect exact from="/system" to={`/system/${systemPages[0].collection}`}/>
			<Route path="/system/:type">
				{systemPages.map((e) => (
					<Route key={e.collection} path={`/system/${e.collection}`}>
						<PageEditor collection={e.collection} name={e.name} />
					</Route>
				))}
			</Route>
		</div>
	);
}

export default System;